export const Day = 24 * 60 * 60 * 1000;
export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["ETRANSFER_ACCESS_TOKEN"] = "etransfer_access_token";
})(LocalStorageKey || (LocalStorageKey = {}));
